import { FC, ReactNode } from 'react'
import classes from './analysisCard.module.scss'

interface AnalysisCardProps {
  buttonText: string
  description: string
  icon: ReactNode
  isChecked?: boolean
  onClick: () => void
  onReviewClick?: () => void
  showReviewButton?: boolean
  title: string
}

export const AnalysisCard: FC<AnalysisCardProps> = ({
  buttonText,
  description,
  icon,
  isChecked = false,
  onClick,
  onReviewClick,
  showReviewButton = false,
  title,
}) => {
  return (
    <div
      className={`${classes.card} ${showReviewButton ? classes.cardExpanded : ''}`}
    >
      {isChecked && (
        <div className={classes.cardCheckmark}>
          <svg fill="none" height="16" viewBox="0 0 24 24" width="16">
            <path
              d="M20 6L9 17L4 12"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </div>
      )}
      <div className={classes.cardIcon}>{icon}</div>
      <h3 className={classes.cardTitle}>{title}</h3>
      <p className={classes.cardDescription}>{description}</p>
      <button className={classes.cardButton} onClick={onClick} type="button">
        {buttonText}
      </button>
      {showReviewButton && onReviewClick && (
        <button
          className={classes.reviewButton}
          onClick={onReviewClick}
          type="button"
        >
          Review & Submit Analysis
          <svg fill="none" height="20" viewBox="0 0 24 24" width="20">
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </button>
      )}
    </div>
  )
}
